import { FikoSahne } from './FikoSahne';
declare var flate: any;
declare var LZUTF8: any;
export class FikoImporterAPTv1 {

    constructor(public sahne?: FikoSahne) {

    }

    async alDosyadan(dosya: any): Promise<any> {
        let json: any;
        let data: string[];
        let isle = (dataStr: string) => {
            let aktivite: any;
            let aktivite_sayac = 0;

            return new Promise((resolve, reject) => {

                data = dataStr.split('\r\n');
                data.shift()
                json = JSON.parse(data.shift());
                // console.log(this.json)

                json.aktiviteler[aktivite_sayac].apt = [];
                json.aktiviteler[aktivite_sayac].islemeEkseni = json.islemeEkseni;
                // json.aktiviteler[aktivite_sayac].noktalar = []

                for (let i = 0; i < data.length; i++) {
                    aktivite = json.aktiviteler[aktivite_sayac];
                    if (!aktivite) {
                        break;
                    }
                    const satir = data[i];
                    if (!satir.startsWith("#FIKOYT AKTIVITE BITIS: ")) {
                        // aktivite.apt += satir + "\r\n";
                        json.aktiviteler[aktivite_sayac].apt.push(satir)
                        // satirIsle(satir)
                    } else {
                        // aktivite.apt += satir + "\r\n";
                        json.aktiviteler[aktivite_sayac].apt.push(satir)
                        // satirIsle(satir)
                        aktivite_sayac++;
                        aktivite = json.aktiviteler[aktivite_sayac]
                        if (aktivite) {
                            // aktivite.apt = ""
                            // aktivite.noktalar = []
                            aktivite.apt = []
                            aktivite.islemeEkseni = json.islemeEkseni;
                        }
                    }
                }

                // console.log(json)

                data = undefined;
                // delete data;
                resolve(json);
                // this.json = undefined;
                // delete this.json;
                // delete sonDevir;
                // delete sonHiz;
                // delete sonKoor;
                // delete sonHizTuru;
                // delete sonTakim;
                // delete sonTakimYonu;
                /** NOT: Loader Bitimi */
            });
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = async (e) => {
                const buffer = e.target?.result as ArrayBuffer;
                let text: string;
                try {
                    text = new TextDecoder('utf-8', { fatal: true }).decode(buffer);
                } catch {
                    text = new TextDecoder('windows-1254').decode(buffer);
                }
                isle(text).then(() => {
                    resolve(json);
                    json = undefined;
                });
            };
            reader.onerror = () => reject(reader.error);
            reader.readAsArrayBuffer(dosya);
        });
    }

    parcala(veri: any) {
        let json: any;
        let data: string[];
        let isle = (dataStr: string) => {
            let aktivite: any;
            let aktivite_sayac = 0;

            data = dataStr.split('\r\n');
            data.shift()
            json = JSON.parse(data.shift());
            // console.log(json)


            json.aktiviteler[aktivite_sayac].apt = [];
            json.aktiviteler[aktivite_sayac].islemeEkseni = json.islemeEkseni;
            // json.aktiviteler[aktivite_sayac].noktalar = []

            for (let i = 0; i < data.length; i++) {
                aktivite = json.aktiviteler[aktivite_sayac];
                if (!aktivite) {
                    break;
                }
                const satir = data[i];
                if (!satir.startsWith("#FIKOYT AKTIVITE BITIS: ")) {
                    // aktivite.apt += satir + "\r\n";
                    json.aktiviteler[aktivite_sayac].apt.push(satir)
                    // satirIsle(satir)
                } else {
                    // aktivite.apt += satir + "\r\n";
                    json.aktiviteler[aktivite_sayac].apt.push(satir)
                    // satirIsle(satir)
                    aktivite_sayac++;
                    aktivite = json.aktiviteler[aktivite_sayac]
                    if (aktivite) {
                        // aktivite.apt = ""
                        // aktivite.noktalar = []
                        aktivite.apt = []
                        aktivite.islemeEkseni = json.islemeEkseni;
                    }
                }
            }

            // console.log(json)

            data = undefined;
            // delete data;
            return json;
            // this.json = undefined;
            // delete this.json;
            // delete sonDevir;
            // delete sonHiz;
            // delete sonKoor;
            // delete sonHizTuru;
            // delete sonTakim;
            // delete sonTakimYonu;

            /** NOT: Loader Bitimi */

        }

        return isle(veri)
    }

    async parcalaAsync(veri: any) {
        let json: any;
        let data: string[];
        let isle = (dataStr: string) => {
            let aktivite: any;
            let aktivite_sayac = 0;

            return new Promise((resolve, reject) => {

                data = dataStr.split('\r\n');
                data.shift()
                json = JSON.parse(data.shift());
                // console.log(json)


                json.aktiviteler[aktivite_sayac].apt = [];
                json.aktiviteler[aktivite_sayac].islemeEkseni = json.islemeEkseni;
                // json.aktiviteler[aktivite_sayac].noktalar = []

                for (let i = 0; i < data.length; i++) {
                    aktivite = json.aktiviteler[aktivite_sayac];
                    if (!aktivite) {
                        break;
                    }
                    const satir = data[i];
                    if (!satir.startsWith("#FIKOYT AKTIVITE BITIS: ")) {
                        // aktivite.apt += satir + "\r\n";
                        json.aktiviteler[aktivite_sayac].apt.push(satir)
                        // satirIsle(satir)
                    } else {
                        // aktivite.apt += satir + "\r\n";
                        json.aktiviteler[aktivite_sayac].apt.push(satir)
                        // satirIsle(satir)
                        aktivite_sayac++;
                        aktivite = json.aktiviteler[aktivite_sayac]
                        if (aktivite) {
                            // aktivite.apt = ""
                            // aktivite.noktalar = []
                            aktivite.apt = []
                            aktivite.islemeEkseni = json.islemeEkseni;
                        }
                    }
                }

                // console.log(json)

                data = undefined;
                // delete data;
                resolve(json);
                // this.json = undefined;
                // delete this.json;
                // delete sonDevir;
                // delete sonHiz;
                // delete sonKoor;
                // delete sonHizTuru;
                // delete sonTakim;
                // delete sonTakimYonu;

                /** NOT: Loader Bitimi */
            });
        }

        return new Promise((resolve, reject) => {

            isle(veri).then(() => {
                resolve(json);
                data = undefined;
                json = undefined;
            });

            /** NOT: Promise Bitimi */
        });
    }


}